import React, { useState } from "react";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import { RoutePath } from "../../utilities/Constants";

function ProductCard({ project, user, handleSingleDelete }) {
  const { productAdd } = RoutePath;
  const [showMore, setShowMore] = useState(false);
  const [visibility, setVisibility] = useState(true);

  const handleDelete = async () => {
    const res = await handleSingleDelete(project._id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  };

  return (
    <>
      {visibility ? (
        <div
          className={`group relative min-h-[20rem] md:min-h-[28rem] h-full flex flex-col justify-between overflow-hidden bg-white dark:bg-darkModeBg dark:border-gray-600 border-dashed ${
            project
              ? "border"
              : "border hover:border-secondary dark:hover:border-secondary transition-colors duration-150"
          } rounded-lg w-full`}
        >
          {project ? (
            <>
              <div>
                <figure>
                  <img
                    src={project?.products?.image}
                    alt={project?.products?.title}
                    className="h-[150px] md:h-[230px] object-cover w-full"
                  />
                </figure>
                <div className="p-4 h-auto flex flex-col gap-1 justify-between">
                  <div className="w-full pb-2 transition-all duration-150">
                    <h2 className="text-lg font-semibold line-clamp-3">
                      {project?.products?.title}
                    </h2>
                    <p className={`relative w-full text-gray-400 `}>
                      {showMore
                        ? project.products?.description
                        : `${project.products?.description?.substring(0, 100)}`}
                    </p>
                    <div className="flex justify-end items-center">
                      <button
                        onClick={() => setShowMore((old) => !old)}
                        className="text-sm text-blue-400 hover:text-blue-600"
                      >
                        {project.products?.description?.length > 99 &&
                          (showMore ? "Show less" : "Show more")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-3 px-4 flex justify-between border-t border-dashed dark:border-gray-600 gap-2 text-sm md:text-base">
                <Link
                  to={`/products/${project._id}`}
                  className="btn btn-outline btn-xs border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 hover:text-white py-1.5 w-24 transition duration-150 border text-center rounded-lg"
                >
                  Edit
                </Link>
                {user === "admin" && (
                  <button
                    title="Delete"
                    id={project._id}
                    onClick={handleDelete}
                    className="btn btn-outline btn-xs border-red-500 text-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white py-1.5 w-24 transition duration-150 border text-center rounded-lg"
                  >
                    Delete
                  </button>
                )}
              </div>
            </>
          ) : (
            <Link className="h-full" to={`/${productAdd}`}>
              <div className="flex justify-center w-full md:min-h-[28rem] h-full items-center">
                <p className="text-6xl text-gray-500 group-hover:text-secondary transition-colors duration-150">
                  <AiOutlineAppstoreAdd />
                </p>
              </div>
            </Link>
          )}
        </div>
      ) : null}
    </>
  );
}

export default ProductCard;
